import { axiosInstance as request } from '@api/rest.service'

/**
 * @description GET /charts/renewal-status
 * @returns {AxiosPromise<any>}
 */
export const GET_RENEWAL_STATUS_CHART = fpId => request.get(`/charts/renewal-status?financialPeriodId=${fpId}`)

/**
 * @description GET /charts/renewal-status/underlying-data?status={status}&paginated=true
 * @returns {AxiosPromise<any>}
 */
export const GET_PAGINATED_RENEWAL_STATUS = (params, status) =>
  request.get('/charts/renewal-status/underlying-data?paginated=true', {
    params: {
      ...params,
      status
    }
  })

/**
 * @description GET /charts/total-spend
 * @returns {AxiosPromise<any>}
 */
export const GET_TOTAL_SPEND_CHART = () => request.get('/charts/total-spend')
